module.exports = __webpack_public_path__ + "img/volume-mute-solid.17bb31c8.svg";